import {Link, Navigate, useSearchParams} from "react-router-dom";
import {Page} from "../Page";
import {Button, Text} from "@wakelet/ui-kit";
import {OAuthStore} from "../../components/auth/store";
import {useEffect, useState} from "react";
import {AccountsAPI} from "../../accounts-api/accounts-api";
import {AuthenticationMethod} from "../../components/auth/method";
import {useNavigate} from "react-router";

export const OAuthStartPage = () => {
  const navigate = useNavigate()
  const [params] = useSearchParams();
  const [authMethod, setAuthMethod] = useState<AuthenticationMethod>();
  const isDev = params.get("dev") === "true";
  const sessionId = OAuthStore.getSession() || "";

  useEffect(() => {
    AccountsAPI.getMethod(sessionId)
    .then(res => setAuthMethod(res))
    .catch(err => {
      console.error(err);
      navigate("/error")
    });
  }, []);
  if (!authMethod) {
    return null;
  }
  if (isDev) {
    const {method, url} = authMethod
    return <DevPageContent sessionId={sessionId} method={method} url={url}/>
  }
  setPendingAuthCookie(authMethod);
  return <Navigate to={authMethod.url}/>;
};

const DevPageContent = ({sessionId, method, url}: DevPageProps) => {
  return (
      <Page>
        <Text.Heading level={1}>OAuth Start Page</Text.Heading>
        <div>sessionId: {sessionId}</div>
        <Button.Style block>
          <Link to={url}>
            <Button.Label text={method}/>
          </Link>
        </Button.Style>
      </Page>
  );
};

type DevPageProps = { sessionId: string, method: string, url: string };

const setPendingAuthCookie = (method: AuthenticationMethod) => {
  const payload = encodeURIComponent(JSON.stringify({
    type: method.method,
    ts: Date.now(),
  }));
  document.cookie = `wk_pending_auth=${payload}; Max-Age=600; Path=/; Domain=.wakelet.com; SameSite=Lax; Secure`;
}